import { AppUser } from '@eventr/common'
import { ColoursObj, Icon } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { DisclosureGroup } from '../../common/DisclosureGroup'
import i18n from '../../i18n/i18next'
import { bs, useBoundStore } from '../../state/bound.store'
import { TeamDepartments } from './TeamDepartments'

interface ITeamMembersProps {
    users: AppUser[]
    stickyHeader?: boolean
    initOpen?: boolean
}

export const TeamMembers = ({
    users,
    stickyHeader = true,
    initOpen = false,
}: ITeamMembersProps) => {
    const currentUser = bs().getCurrentUser()

    const itineraryDepsAndGroups = useBoundStore
        .getState()
        .selectedItineraryGroupsAndDepartments()

    if (users.length < 1) {
        return null
    }

    const usersWithTags =
        bs().selectedItineraryUsersOnlyFromGroupsAndDepartments(users)
    const otherUser = users.filter((user) => {
        if (usersWithTags.includes(user)) {
            return false
        } else {
            return true
        }
    })

    return (
        <DisclosureGroup
            id="teamMembers"
            stickyHeader={stickyHeader}
            childrenHandlePadding
            title={i18n.t('team.members')}
            containerStyle={{
                backgroundColor: ColoursObj.backgrounds.primary,
            }}
            isOpen={initOpen}
            icon={<Icon name="Users" />}
            content={
                <Stack paddingBottom="8px" bgcolor="transparent">
                    {itineraryDepsAndGroups.map((tag, index) => {
                        return (
                            <TeamDepartments
                                tag={tag.name}
                                users={usersWithTags}
                                currentUser={currentUser}
                                key={index + tag.name}
                            />
                        )
                    })}

                    <TeamDepartments
                        tag="Other"
                        users={otherUser}
                        currentUser={currentUser}
                        hideHeader={itineraryDepsAndGroups.length === 0}
                    />
                </Stack>
            }
            count={usersWithTags.length + otherUser.length}
        />
    )
}
